'use client';

import useEligibleUSPayment from './useEligibleUSPayment';
import useFeatureFlag from './useFeatureFlag';

const useDisplayAffirm = (): boolean => {
  const enabled = useFeatureFlag('show-affirm');
  const isEligible = useEligibleUSPayment();
  return enabled && isEligible;
};

export default useDisplayAffirm;
